import { useTranslation } from 'react-i18next';

import { ICalculationResponse } from '../../../../../../../../../../../shared/interfaces/IFootprint';
import { calculateEmissionBreakdownValues } from '../helpers';
import EmissionsBreakdownValueCard from './cards/EmissionsBreakdownValueCard';
import EmissionsBreakdownChart from './EmissionsBreakdownChart';

type EmissionBreakdownSectionProps = {
  calculationResponse?: ICalculationResponse;
};

const EmissionBreakdownSection = ({
  calculationResponse,
}: EmissionBreakdownSectionProps): JSX.Element => {
  const { t } = useTranslation();

  // Calculate emission values for each category
  const emissionValues = calculateEmissionBreakdownValues(calculationResponse);

  const chartData = [
    {
      key: 'materialInputs',
      value: emissionValues[0],
      color: 'green',
      title: t('calculationDetailsPage.sections.emissionsBreakdown.materialInputs'),
    },
    {
      key: 'energyConsumption',
      value: emissionValues[1],
      color: 'orange',
      title: t('calculationDetailsPage.sections.emissionsBreakdown.energyConsumption'),
    },
    {
      key: 'transportation',
      value: emissionValues[2],
      color: 'blue',
      title: t('calculationDetailsPage.sections.emissionsBreakdown.transportation'),
    },
    {
      key: 'wasteTreatment',
      value: emissionValues[3],
      color: 'purple',
      title: t('calculationDetailsPage.sections.emissionsBreakdown.wasteTreatment'),
    },
  ].filter((item) => {
    return item.value > 0;
  });

  return (
    <div className='flex flex-column gap-2 w-full'>
      <h5 className='p-0 m-0 font-medium'>
        {t('calculationDetailsPage.sections.emissionsBreakdown.title')}
      </h5>

      <div className='flex w-full mb-2'>
        <EmissionsBreakdownChart data={chartData} />
      </div>

      <div className='grid grid-nogutter w-full m-0'>
        {chartData.map((data, index) => {
          return (
            <EmissionsBreakdownValueCard
              key={data.key}
              title={data.title}
              value={data.value}
              color={data.color}
              index={index}
            />
          );
        })}
      </div>
    </div>
  );
};

export default EmissionBreakdownSection;
